// @ts-nocheck


import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState } from

'react';
import notification from 'antd/lib/notification';

import PageHeader from './PageHeader';

import { PageContext, FilterContext } from './PageContext';
import { notificationLoading } from '../../../Notifications';

import { Icon, Table, Popconfirm } from '../../../ui';
import { Section } from '../../../layout';






















































// Состояние для служебных колонок






// обработчик состояния служебных колонок
const columnsReducer = (state, action) => {
  switch (action.type) {
    case 'add':
      return [...state, ...(action.columns ?? [])];
    case 'delete':
      return state.filter((col) => col.dataIndex !== action.dataIndex);
    default:
      throw Error('Unexpected action');
  }
};

export default (props) => {
  const page = useContext(PageContext);
  const filter = useContext(FilterContext);

  const [totalCount, setTotalCount] = useState(0);

  const [data, setData] = useState(props.tableListProps.data ?? []);
  const [mixinColumnsState, dispatchMixinColumns] = useReducer(
    columnsReducer,
    []
  );
  const [loading, setLoading] = useState(false);

  const [deleting, setDeleting] = useState(false);
  useEffect(() => {
    if (deleting) {
      notificationLoading({
        message: 'Удаление записи...',
        key: 'deleting'
      });
    } else {
      notification.destroy('deleting');
    }
    return () => {
      notification.destroy('deleting');
    };
  }, [deleting]);

  const handleFetch = useCallback(async () => {
    setLoading(true);
    try {
      const p = { page, ...props.filterMixin, ...filter };
      const data =
      (await props.crud?.fetch(p)) || (await props.oldCrud?.onFetch?.(p));
      if (!data) {
        notification.warning({ message: 'Не удалось запросить данные' });
        return;
      }
      setData(data.data);
      setTotalCount(data.totalCount);
    } catch (error) {
      notification.error({ message: 'Не удалось запросить данные' });
    } finally {
      setLoading(false);
    }
  }, [filter, page, props.crud, props.filterMixin, props.oldCrud]);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  useEffect(() => {
    if (props.reFetch) {
      handleFetch();
    }
  }, [props.reFetch, handleFetch]);

  const handleRowDelete = useCallback(
    async (id) => {
      setDeleting(true);
      try {
        (await props.crud?.delete(id)) || (await props.oldCrud?.onDelete?.(id));
        await handleFetch();
      } catch (error) {
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
      setDeleting(false);
    },
    [handleFetch, props.crud, props.oldCrud]
  );

  useEffect(() => {
    if (props.tableListProps.canDelete) {
      dispatchMixinColumns({
        type: 'add',
        columns: [
        {
          stopPropagation: true,
          width: 20,
          dataIndex: 'id',
          render: (id) =>
          <Popconfirm
            title="Вы уверены, что хотите удалить запись?"
            onConfirm={async () => await handleRowDelete(id)}>

                <Icon type="x" />
              </Popconfirm>

        }]

      });
    } else {
      dispatchMixinColumns({ type: 'delete', dataIndex: 'id' });
    }
  }, [handleRowDelete, props.tableListProps.canDelete]);

  const handleRowClick = async (id) => {
    await props.tableListProps.onSelect?.(id);
  };

  const applyFilter = async () => {
    await handleFetch();
  };

  const cleanFilter = async () => {
    await handleFetch();
  };

  const Filter = () => {
    let afilter;
    if (props.filter) {
      if (React.isValidElement(props.filter)) {
        // $FlowFixMe проверка на undefined есть
        afilter = React.cloneElement(props.filter, {
          cleanFilter,
          applyFilter,
          filter
        });
      } else {
        afilter = props.filter?.({ cleanFilter, applyFilter, filter });
      }
    }
    return afilter || null;
  };

  return (
    <>
      <PageHeader {...props.pageHeaderProps} />
      {props.subHeader}
      <Section>
        <Filter />
        <Table
          onRow={(record) => ({
            onClick: () => handleRowClick(record.id)
          })}
          loading={loading}
          data={data}
          columns={[...props.tableListProps.columns, ...mixinColumnsState]}
          pagination={{
            page,
            totalCount,
            pageSize: props.tableListProps.pageSize || 20
          }}
          rowKey={props.tableListProps.rowKey ?? 'id'} />

      </Section>
    </>);

};
